import type { FC } from 'react'
import type { ScreeningOutcomeProps } from './types'
import { Typography } from '../Typography'
import clsx from 'clsx'
import {
  OUTCOME_TO_STROKE_CLASS,
  OUTCOME_TO_TYPOGRAPHY_CLASS,
} from './constants'

export const ScreeningOutcome: FC<ScreeningOutcomeProps> = ({ outcome }) => {
  const typographyClass = OUTCOME_TO_TYPOGRAPHY_CLASS[outcome]
  const strokeClass = OUTCOME_TO_STROKE_CLASS[outcome]

  return (
    <div className="relative flex h-[52px] w-[52px] items-center justify-center">
      <svg
        viewBox="0 0 52 52"
        preserveAspectRatio="xMidYMid meet"
        className="absolute inset-0"
      >
        <circle
          cx="26"
          cy="26"
          r="22"
          strokeWidth={2}
          strokeDasharray={3.8}
          fill="none"
          className={strokeClass}
        />
      </svg>
      <Typography
        size="xs"
        weight="regular"
        className={clsx(typographyClass, 'text-center !leading-3 max-w-11')}
      >
        {outcome}
      </Typography>
    </div>
  )
}
